/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwf_Choose_StatusInputs */

const en_pwf_choose_status = /** @type {(inputs: Pwf_Choose_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a status`)
};

const de_pwf_choose_status = /** @type {(inputs: Pwf_Choose_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status wählen`)
};

/**
* | output |
* | --- |
* | "Choose a status" |
*
* @param {Pwf_Choose_StatusInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_choose_status = /** @type {((inputs?: Pwf_Choose_StatusInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_Choose_StatusInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_choose_status(inputs)
	return en_pwf_choose_status(inputs)
});